import { BaseModel, DateModel } from "~/model"
import {
    useDataCacheStore,
    useProjetStore,
    usePersonnelStore,
    useAuthStore,
    useRdvStore,
} from "~/stores"
import { RdvResource } from "~/api"

export class RdvModel extends BaseModel<RdvResource> {
    static primaryKey = "IDRDV"

    get dataCacheStore() {
        return useDataCacheStore()
    }

    get projetStore() {
        return useProjetStore()
    }

    get personnelStore() {
        return usePersonnelStore()
    }

    get authStore() {
        return useAuthStore()
    }

    getFormatted() {
        const dataCacheStore = useDataCacheStore()
        const typeEvent = dataCacheStore.natureRDV?.find(
            (nature) => nature.IDNATURE_RDV === this.IDNATURE_RDV,
        )

        return {
            title: this.RDV_OBJET,
            start: new Date(this.RDV_DEBUT),
            end: new Date(this.RDV_FIN),
            id: this.IDRDV,
            data: this,
            color: typeEvent?.CODECOULEUR || "#000000",
            timed: true,
            typeEvent: "rdv",
        }
    }

    get dateDebut() {
        return DateModel.formatDateTime(this.RDV_DEBUT)
    }

    get libelleNature() {
        const nature = this.dataCacheStore.natureRdvById[this.IDNATURE_RDV]
        return nature?.LIBELLE || "Nature inconnue"
    }

    get isCommercial() {
        const nature = this.dataCacheStore.natureRdvById[this.IDNATURE_RDV]
        return nature?.CODE === "Com"
    }

    get isMetre() {
        const nature = this.dataCacheStore.natureRdvById[this.IDNATURE_RDV]
        return nature?.CODE === "Metre"
    }

    get isR2() {
        const nature = this.dataCacheStore.natureRdvById[this.IDNATURE_RDV]
        return nature?.CODE === "R2"
    }

    get isAutre() {
        const nature = this.dataCacheStore.natureRdvById[this.IDNATURE_RDV]
        return nature?.CODE === "Autre"
    }

    get hasDebrief() {
        const nature = this.dataCacheStore.natureRdvById[this.IDNATURE_RDV]
        return ["Com", "R1", "R2", "R3"].includes(nature?.CODE)
    }

    get titleDate() {
        const difference = DateModel.formatDifference(
            this.RDV_DEBUT,
            this.RDV_FIN,
        )

        const date = DateModel.formatCompleteDay(this.RDV_DEBUT)
        const hour = DateModel.formatTime(this.RDV_DEBUT)

        return `${date} <b>${hour}</b> (${difference})`
    }

    get projet() {
        return this.projetStore.itemById[this.IDPROJET]
    }

    get personnelsWithoutMe() {
        const currentUserId = this.authStore.mainToken?.tokenable_id
        if (!this.IDPERSONNELS) return []
        return this.IDPERSONNELS.filter(
            (id: number) => id !== currentUserId,
        ).map((id: number) => this.personnelStore.itemById[id])
    }

    get currentPersonnelRdv() {
        const rdvStore = useRdvStore()
        const userId =
            rdvStore.idPersonnelImpersonate ||
            this.authStore.mainToken?.tokenable_id
        return (this.RDV_PERSONNEL as any)?.find(
            (p: any) => p.IDPERSONNEL === userId,
        )
    }

    get isPrepareOrRealise() {
        const personnelRdv = this.currentPersonnelRdv
        return !!(personnelRdv?.RDV_PREPARE || personnelRdv?.RDV_REALISE)
    }

    get hasObservations() {
        return !!this.OBSERVATIONS?.trim()
    }
}

export interface RdvModel extends RdvResource {}
